<template>
  <div>
    <table-view
      ref="tableList"
      is-search-row
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="Parameter Setting LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void (0)"
          class="icon-pencil1"
          style="margin-right: 20px; color: #3a3f63"
          @click="handleEdit(tableRow.row)"
        />
        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemoveItem(tableRow.row.id)"
        >
          <a
            href="javascript:void(0)"
            class="icon-trash1"
            style="color: #3a3f63"
            slot="reference"
          />
        </el-popconfirm>
      </template>
    </table-view>

    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="462px"
      @close="handleClose"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-card :bordered="false">
        <el-form :model="form" ref="form" label-position="top" :rules="rules">
          <el-form-item label="Parameter Name" prop="name">
            <el-input style="width: 100%" v-model="form.name" />
          </el-form-item>
          <el-form-item label="Parameter Identification" prop="mark">
            <el-input style="width: 100%" v-model="form.mark" />
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer">
        <customize-button style="margin-right: 20px" @click="visible = false">
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSave">
          Save
        </customize-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTableData, updateOrAdd, removeItem } from './api'

export default {
  data() {
    const tableModel = [
      {
        label: 'Parameter Name',
        prop: 'name',
      },
      {
        label: 'Parameter Identification',
        prop: 'mark',
      },
      {
        label: 'Action',
        width: 120,
        slotName: 'action',
      },
    ]
    return {
      tableModel: tableModel,
      tableData: [],
      pages: {},
      visible: false,
      form: {
        name: '',
        mark: '',
      },
      rules: {
        name: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
        mark: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
      },
    }
  },
  mounted() {
    this.initTable()
  },
  methods: {
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    handleClose() {
      this.formId = ''
      this.$refs.form.resetFields()
    },
    async handleSave() {
      try {
        const valid = await this.$refs.form.validate()
        if (valid) {
          const submitData = { ...this.form }
          if (this.formId) submitData.id = this.formId
          await this.handleUpdateOrAdd(submitData)
        }
      } catch (err) {
        console.error(err)
      }
    },
    async handleUpdateOrAdd(params) {
      try {
        await updateOrAdd(params)
        this.$message.success('success')
        this.initTable()
        this.visible = false
      } catch (err) {
        console.error(err)
      }
    },
    async handleTitleActionBtn() {
      this.visible = true
    },
    handleEdit(row) {
      this.visible = true
      this.formId = row.id

      this.$nextTick(() => {
        Object.keys(this.form).forEach(key => (this.form[key] = row[key]))
      })
    },
    async handleRemoveItem(id) {
      try {
        await removeItem(id)
        this.$message.success('success')
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
